<template>
  <div style="background-color: white; margin: 10px 20px">
    <div class="pos_container_panel">
      <loading :loading="wholeLoading" />
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-row>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="国家">
                <el-select filterable
                  default-first-option
                  @clear="setValueNullcountry"
                  clearable
                  v-model="searchForm.nation"
                  placeholder="国家"
                  :loading="loadingNationS"
                  style="width: 82%; margin-left: 3.5rem"
                  @change="selectNation">
                  <el-option v-for="item in nationoption" :key="item.countryCode" :label="item.countryName" :value="item.countryCode"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="州/省">
                <el-select
                  filterable
                  default-first-option
                  @clear="setValueNullprovince"
                  clearable
                  @change="selectProvince"
                  v-model="searchForm.province"
                  placeholder="州/省"
                  :loading="loadingProvinceS"
                  style="width: 87%; margin-left: 2rem">
                  <el-option v-for="item in provinceoption" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="城市">
                <el-select
                  filterable
                  default-first-option
                  @clear="setValueNullcity"
                  clearable
                  @change="selectCity"
                  v-model="searchForm.city"
                  placeholder="城市"
                  :loading="loadingCityS"
                  style="width: 85%; margin-left: 25px">
                  <el-option v-for="item in cityoption" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="客户名称">
                <el-input size="default" @clear="setValueNull" clearable style="width: 95%; margin-left: 0.5rem" class="myselect_inner" @click="showClientNamePop" v-model="searchForm.client" placeholder="请选择后再搜索或新增"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="类型">
                <el-select filterable v-model="searchForm.locationType" placeholder="类型" style="width: 85%; margin-left: 26px" @change="typechange">
                  <el-option v-for="item in locationtypeoption" :key="item.key" :label="item.type" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <el-form-item label="位置名称">
                <el-input style="width: 94%" v-model="searchForm.nameEN" clearable></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="float: right">
            <div class="grid-content" style="float: right; margin-right: 3rem">
              <el-button type="warning" class="harpIDbtn" @click="customSearch()">搜索</el-button>
              <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addLocation()">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
      <!--table-->
      <el-table :data="tableData" border style="width: 98%; margin-top: 50px">
        <el-table-column prop="cityNameLists.zh-CN" label="城市" align="center"></el-table-column>
        <el-table-column prop="locationshowtype" label="类型" align="center"></el-table-column>
        <el-table-column prop="locationNameLists.zh-CN" label="中文名称" align="center"></el-table-column>
        <el-table-column prop="locationNameLists.en" label="英文名称" align="center"></el-table-column>
        <el-table-column prop="longitude" label="高德-经度" align="center"></el-table-column>
        <el-table-column prop="latitude" label="高德-纬度" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button @click="bindMapping(scope.row)" type="text" size="small">关联映射</el-button>
            <el-button type="text" size="small" @click.prevent="deleteMapping(scope.row)">删除映射</el-button>
            <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
            <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
            <el-button @click="enableClick(scope.row)" type="text" size="small" style="margin-left: 1rem" v-show="scope.row.isEnable == 0">启用</el-button>
            <el-button @click="enableClick(scope.row)" type="text" size="small" v-show="scope.row.isEnable == 1">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="paginationsty"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage1"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <!--新增 dialog-->
    <el-dialog title="区域位置" v-model="dialogFormVisible" @close="closeaddDialog('form')" :close-on-click-modal="false">
      <el-form :model="form" :rules="addlocationrules" ref="form">
        <el-form-item label="客户名称:" :label-width="formLabelWidth" v-show="this.searchForm.locationType == 3">
          <el-input v-model="form.name" autocomplete="off" disabled style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="国家:" :label-width="formLabelWidth" prop="nation">
          <el-select
            filterable
            default-first-option
            @change="selectNationform"
            style="width: 58%; margin-left: 85px"
            class="myselect_inner"
            v-model="form.nation"
            placeholder="请选择"
            :disabled="hidecity">
            <el-option v-for="item in nationoptionform" :key="item.countryCode" :label="item.countryName" :value="item.countryCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="州/省:" :label-width="formLabelWidth" prop="province">
          <el-select
            filterable
            default-first-option
            @change="selectProvinceform"
            style="width: 58%; margin-left: 85px"
            class="myselect_inner"
            v-model="form.province"
            placeholder="请选择"
            :disabled="hidecity">
            <el-option v-for="item in provinceoptionform" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在城市" :label-width="formLabelWidth" prop="city">
          <el-select
            filterable
            default-first-option
            @change="selectCityform"
            :disabled="hidecity"
            style="width: 58%; margin-left: 85px"
            class="myselect_inner"
            v-model="form.city"
            placeholder="请选择">
            <el-option v-for="item in cityoptionform" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型:" :label-width="formLabelWidth">
          <el-select
            :disabled="true"
            style="width: 58%; margin-left: 85px"
            class="myselect_inner"
            v-model="form.locationtype"
            placeholder="请选择">
            <el-option v-for="item in locationtypeoption" :key="item.id" :label="item.type" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中文名称:" :label-width="formLabelWidth" prop="region">
          <el-input v-model="form.region" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="英文名称:" :label-width="formLabelWidth" prop="regionEn">
          <el-input v-model="form.regionEn" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="高德-经度:" :label-width="formLabelWidth" prop="longitude">
          <el-input v-model="form.longitude" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="高德-纬度:" :label-width="formLabelWidth" prop="latitude">
          <el-input v-model="form.latitude" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="多语言名称:" :label-width="formLabelWidth" prop="multiLanguages" :rules="[{required: true,message: '请输入多语言名称',trigger: 'blur'}]">
          <el-input v-model="form.multiLanguages" type="textarea" autocomplete="off" style="width: 58%; margin-left: 85px" ></el-input>
        </el-form-item>
        <el-form-item label="区域位置代码:" :label-width="formLabelWidth" prop="locationCode" v-if="showLocationCode" :rules="[{required: true,message: '请输入区域位置代码',trigger: 'blur',},]">
          <el-input v-model="form.locationCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="customAdd()">保存</el-button>
        <el-button @click="cancelAdd()">取 消</el-button>
      </template>
    </el-dialog>
    <!--删除 dialog-->
    <el-dialog title="" v-model="deletedialogVisible" width="30%" >
      <span>{{this.delMappingMsg !== "" ? this.delMappingMsg : "请确认是否删除"}}</span>
      <template #footer>
        <el-button type="primary" @click="confirmDelete">确 定</el-button>
        <el-button @click="cancelDelete">取 消</el-button>
      </template>
    </el-dialog>
    <!--关联映射-->
    <el-dialog title="关联映射" v-model="bindMappingFlag" >
      <el-form :model="bindMappingForm" ref="bindMappingInput">
        <el-form-item label="GEO编码:" :label-width="formLabelWidth">
          <el-input disabled v-model="bindMappingForm.GEOCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
        <el-form-item label="第三方系统:" :label-width="formLabelWidth">
          <el-select style="width: 58%; margin-left: 85px" class="myselect_inner" v-model="bindMappingForm.remoteSystemCode" placeholder="请选择">
            <el-option v-for="item in remoteSystemList" :key="item.code" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="第三方系统编码:" :label-width="formLabelWidth" prop="remoteSystemMappingCode"
          :rules="[{required: true,message: '请输入第三方系统编码',trigger: 'blur',},]">
          <el-input required v-model="bindMappingForm.remoteSystemMappingCode" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="saveMapping()">保存</el-button>
        <el-button @click="cancel()">取 消</el-button>
      </template>
    </el-dialog>
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>
<script>
import {
  cityconfigList,
  deletelocationList,
  enableList,
  getcountryList,
  getprovinceList,
  locationList,
  savelocationList,
  fetchMapping,
  deleteMapping,
  saveMapping,
} from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
import Loading from "@/components/Loading.vue";
export default {
  name: "HBEAreaLocation",
  components: {
      ConfirmBoxs,
      ClientList,
      Loading,
  },
  data() {
    return {
      formLabelWidth: "150px",
      clientListFlag: false,
      loadingNationS: false,
      loadingProvinceS: false,
      loadingCityS: false,
      wholeLoading: false,
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      searchForm: {
        client: "",
        nation: "",
        province: "",
        locationType: 0,
        city: "",
        nameEN: "", //位置名称
      },
      nationoption: [],
      provinceoption: [],
      cityoption: [],
      locationtypeoption: [
        { id: 0, type: "全部",},
        { id: 1, type: "行政区",},
        { id: 2, type: "机场/火车站",},
        { id: 3, type: "自定义地标",},
        { id: 4, type: "热门地标",},
      ],
      tableData:[],
      currentPage1: 1,
      currPage: 1,
      pageTotal: 0,
      dialogFormVisible: false,
      deletedialogVisible: false,
      hidecity: false,
      form: {
        name: "",
        region: "",
        regionEn: "",
        city: "",
        delivery: false,
        nation:  "",
        province:  "",
        locationtype:  "",
        latitude: "",
        longitude: "",
        locationCode: "",
        multiLanguages: "",
      },
      addlocationrules: {
        city: [{ required: true,message: "请选择国家/城市",trigger: "change",},],
        region: [{ required: true, message: "请输入", trigger: "blur" }],
        regionEn: [{ required: true, message: "请输入", trigger: "blur" }],
        longitude: [{ required: true,message: "请输入正确的高德-经度",pattern: /^(\-|\+)?\d+(\.\d+)?$/,trigger: "blur",},],
        latitude: [{ required: true,message: "请输入正确的高德-纬度",pattern: /^(\-|\+)?\d+(\.\d+)?$/,trigger: "blur",},],
      },
      nationoptionform: [],
      provinceoptionform: [],
      cityoptionform: [],
      showLocationCode: true,
      delMappingMsg: "",
      bindMappingFlag: false,
      bindMappingForm: {
        GEOCode: "",
        remoteSystemCode: "FX",
        remoteSystemMappingCode: "",
      },
      remoteSystemList: [{code: "FX",value: "FX",},],
      locationCode: "",
      clickRow: {},
    };
  },
  mounted() {
    this.getCountryList();
    this.tableData.length = 0;
    this.searchForm.locationType = 0;
  },
  methods: {
    //分页
    handleSizeChange() {
    },
    handleCurrentChange(currPage) {
      this.customSearch(currPage);
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      this.loadingNationS = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          this.loadingNationS = false;
          if (this.dialogFormVisible == true) {
            this.nationoptionform = res.data.list;
          } else {
            this.nationoption = res.data.list;
          }
        });
    },
    async getProvinceList() {
      this.loadingProvinceS = true;
      let searchparams = {
        params: {
          countryCode: this.selectnation,
          provinceCode: "",
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          this.loadingProvinceS = false;
          if (this.dialogFormVisible == true) {
            this.provinceoptionform = res.data.list;
          } else {
            this.provinceoption = res.data.list;
          }
        });
    },
    async getCityList() {
      this.loadingCityS = true;
      let searchparams = {
        params: {
          countryCode: this.selectnation, //"100000"
          provinceCode: this.selectprovince, //"110000"
          cityCode: "", 
        },
      };
      await cityconfigList(searchparams)
        .then((res) => {
          this.loadingCityS = false;
          if (this.dialogFormVisible == true) {
            this.cityoptionform = res.data.list;
          } else {
            this.cityoption = res.data.list;
          }
          this.countryList = res.data.list;
        });
    },
    //国省市客户change/clear事件
    setValueNull() {
      this.locationCode = "";
    },
    setValueNullcity() {
      this.cityCode = "";
      this.form.city = "";
    },
    setValueNullprovince() {
      this.cityoption.length = 0;
      this.searchForm.city = "";
      this.cityCode = "";
    },
    setValueNullcountry() {
      this.cityoption.length = 0;
      this.provinceoption.length = 0;
      this.provinceoptionform.length = 0;
      this.cityoptionform.length = 0;
      this.searchForm.city = "";
      this.searchForm.province = "";
      this.cityCode = "";
    },
    selectNation(vId) {
      let obj = {};
      obj = this.nationoption.find((item) => {
        return item.countryCode === vId; //筛选出匹配数据
      });
      this.addnation = obj.countryName;
      this.selectnation = vId;
      this.searchForm.province = "";
      this.searchForm.city = "";
      this.getProvinceList();
      this.getCityList();
    },
    selectNationform(vId) {
      let obj = {};
      obj = this.nationoptionform.find((item) => {
        return item.countryCode === vId; //筛选出匹配数据
      });
      this.selectnation = vId;
      this.form.province = "";
      this.form.city = "";
      this.getProvinceList();
      this.getCityList();
    },
    selectProvince(vId) {
      let obj = {};
      obj = this.provinceoption.find((item) => {
        return item.provinceCode === vId; //筛选出匹配数据
      });
      this.selectprovince = vId;
      this.searchForm.city = "";
      this.addcity = "";
      this.getCityList();
    },
    selectProvinceform(vId) {
      let obj = {};
      obj = this.provinceoptionform.find((item) => {
        return item.provinceCode === vId; //筛选出匹配数据
      });
      this.selectprovince = vId;
      this.form.city = "";
      this.getCityList();
    },
    selectCity(vId) {
      let obj = {};
      obj = this.cityoption.find((item) => {
        return item.cityCode === vId; //筛选出匹配数据
      });
      this.addcity = obj.cityName;
      this.cityCodesearch = vId;
      this.cityId = obj.cityId;
    },
    selectCityform(vId) {
      let obj = {};
      obj = this.cityoptionform.find((item) => {
        return item.cityCode === vId; //筛选出匹配数据
      });
      this.cityCodeform = vId;
      this.cityIdform = obj.cityId;
    },
    //搜索button
    async customSearch(page) {
      this.wholeLoading = true;
      this.currPage = page ? page : 1;
      if (this.searchForm.locationType != 3 || this.locationCode) {
        if (this.searchForm.nation != "" && this.searchForm.city == "") {
          this.confirmFlag = true;
          this.confirmMsg = "请先选择城市后再搜索";
          this.wholeLoading = false;
        } else {
          let searchparams = {
            params: {
              locationType: this.searchForm.locationType, // this.selecttype 类型
              customerCode: this.locationCode, //? 客户名称
              cityCode: this.cityCodesearch, //城市 this.cityCode
              locationCode: "", //不必要
              locationName: this.searchForm.nameEN, //位置名称？
              page: this.currPage,
              per_page: 10,
            },
          };
          await locationList(searchparams)
            .then((res) => {
              this.wholeLoading = false;
              this.pageTotal = res.data.total;
              this.currentPage1 = res.data.pageNumber;
              this.tableData = res.data.list;
              this.tableData.forEach((item) => {
                switch (item.locationType) {
                  case 4:
                    item.locationshowtype = "热门地标";
                    break;
                  case 3:
                    item.locationshowtype = "自定义地标";
                    break;
                  case 2:
                    item.locationshowtype = "机场/火车站";
                    break;
                  default:
                    item.locationshowtype = "行政区";
                }
              });
            });
        }
      } else if (this.locationCode == "") {
        this.confirmFlag = true;
        this.confirmMsg = "请先选择公司后再搜索";
        this.wholeLoading = false;
      }
    },
    //新增
    async customAdd() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          switch (this.form.locationtype) {
            case "热门地标":
              this.addlocationtype = 4;
              break;
            case "自定义地标":
              this.addlocationtype = 3;
              break;
            case "机场/火车站":
              this.addlocationtype = 2;
              break;
            case "行政区":
              this.addlocationtype = 1;
              break;
          }
          let locationCode = this.clickRow.locationCode
            ? this.clickRow.locationCode
            : this.form.locationCode; //新增不传 修改传 31010000001017
          let cityCode;
          if (this.operationType == "add") {
            cityCode = this.cityCodeform ? this.cityCodeform : this.cityCodesearch;
          }
          if (this.operationType == "edit") {
            cityCode = this.clickRow.cityCode;
          }
          let cityID;
          if (this.operationType == "add") {
            cityID = this.cityIdform ? this.cityIdform : this.cityId;
          }
          if (this.operationType == "edit") {
            cityID = this.clickRow.cityID;
          }
          let companyGuid = this.locationCode;
          let saveparams = {
            locationName: this.form.region, //? true 中文名称 locationname (this.form.region)
            id: 0,
            locationCode: locationCode, //true 31010000001017
            aliasName: this.form.region, ///? "locationName": this.form.region
            locationType: this.addlocationtype, //true
            timeZone: "",
            frequentlyUsedFlag: 0,
            latitude: this.form.latitude,
            longitude: this.form.longitude,
            geoCodeType: "autonavi",
            cityCode: cityCode, //true "110100"
            cityId: cityID,
            companyGuid: companyGuid, //YGO00001
            multiLanguages: this.form.multiLanguages,
            locationNames: [
              {
                languageCode: "zh-CN",
                locationName: this.form.region, ///??this.form.regionEn
                description: "",
              },
              {
                languageCode: "en",
                locationName: this.form.regionEn, ///??this.form.regionEn
                description: "",
              },
            ],
          };
          let $this = this;
          savelocationList(saveparams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 2002) {
                  $this.confirmFlag = true;
                  $this.confirmMsg = res.data.error.message;
                } else {
                  $this.confirmFlag = true;
                  $this.confirmMsg = "操作成功";
                  $this.currPage = 1;
                  $this.cityCode = this.clickRow.cityCode
                    ? this.clickRow.cityCode
                    : $this.form.city;
                  this.dialogFormVisible = false;
                  $this.customSearch();
                }
              }
            });
        } else {
          this.confirmFlag = true;
          this.confirmMsg = "请正确选择和填写所有项目";
          return false;
        }
      });
    },
    // 新增button
    addLocation() {
      this.operationType = "add";
      this.hidecity = false;
      this.clickRow.locationCode = "";
      this.cityIdform = "";
      if (this.operationType == "edit") {
        this.clickRow.cityCode = "";
      }
      if(this.searchForm.locationType == "3"){
        this.showLocationCode = false;
      }else{
        this.showLocationCode = true;
      }
      this.addlocation = true;
      this.form.latitude = "";
      this.form.longitude = "";
      this.form.region = "";
      this.form.regionEn = "";
      this.cityIdform = "";
      this.cityCodeform = "";
      this.selectprovince = "";
      this.nationoptionform = this.nationoption;
      this.form.nation = this.searchForm.nation ? this.searchForm.nation : "";
      this.provinceoptionform = this.provinceoption;
      this.form.province = this.searchForm.province ? this.searchForm.province : "";
      this.cityoptionform = this.cityoption;
      this.form.city = this.searchForm.city ? this.searchForm.city : "";
      this.form.locationCode = "";
      this.form.multiLanguages = "";
      if (this.searchForm.locationType == "" || this.searchForm.locationType == 0) {
        this.confirmFlag = true;
        this.confirmMsg = "请先选择类型";
      } else if (this.searchForm.locationType == 3 && this.locationCode == "") {
        this.confirmFlag = true;
        this.confirmMsg = "请先选择公司后再添加";
      } else {
        this.dialogFormVisible = true;
      }
    },
    //修改button
    handleClick(row) {
      this.operationType = "edit";
      this.hidecity = true;
      this.addlocation = false;
      this.clickRow = row;
      this.dialogFormVisible = true;
      this.cityoptionform = this.cityoption;
      this.form.region = this.clickRow.locationName;
      this.form.regionEn = this.clickRow.locationNameLists.en;
      this.form.city = this.clickRow.cityNameLists["zh-CN"];
      this.form.locationtype = this.clickRow.locationshowtype;
      this.form.longitude = this.clickRow.longitude;
      this.form.latitude = this.clickRow.latitude;
      this.form.locationCode = this.clickRow.locationCode;
      this.form.multiLanguages =  this.clickRow.multiLanguages;
      this.showLocationCode = false;
      this.form.nation = this.clickRow.countryNameLists["zh-CN"];
      this.form.province = this.clickRow.provinceNameLists["zh-CN"];
    },
    //启用button
    async enableClick(row) {
      switch (row.isEnable) {
        case 0:
          row.isEnable = 1;
          break;
        case 1:
          row.isEnable = 0;
          break;
      }
      let params = {
        params: {
          type: 3,
          code: row.locationCode, //启用地区的code
          action: row.isEnable, // 1-Enable 0-Disable    1显示禁用 0显示启用
        },
      };
      await enableList(params)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "操作成功";
          }
        });
    },
    // 保存关联映射
    saveMapping() {
      this.$refs["bindMappingInput"].validate(async (valid) => {
        if (valid) {
          const bindMappingForm = this.bindMappingForm;
          this.wholeLoading = true;
          this.bindMappingFlag = false;
          const saveMappingRequests = {
            type: "locationmapping",
            data: {
              locationCode: bindMappingForm.locationCode,
              locationId: bindMappingForm.locationId
                ? bindMappingForm.locationId
                : "",
              remoteSystemCode: bindMappingForm.remoteSystemCode,
              remoteSystemLocationCode: bindMappingForm.remoteSystemMappingCode,
              userName: this.$objBaseInfo.loginID,
            },
          };
          let confirmMsg = "";
          await saveMapping(saveMappingRequests)
            .then(async (res) => {
              if (res.code === 200) {
                if (res.data.status === 1) {
                  confirmMsg = "已成功关联映射";
                } else {
                  confirmMsg = "关联映射失败，请重新操作";
                }
              } else {
                confirmMsg = res.data.error.message;
              }
            });
          if (confirmMsg !== "") {
            this.wholeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = confirmMsg;
          }
        }
      });
    },
    // 关联映射
    async bindMapping(row) {
      const fetchMappingRequests = {
        type: "locationmapping",
        paramsObj: {
          params: {
            locationCode: row.locationCode,
            remoteSystemCode: "FX",
          },
        },
      };
      var fetchMappingData = await fetchMapping(fetchMappingRequests);
      this.bindMappingFlag = true;
      let bindMappingForm = this.bindMappingForm;
      bindMappingForm.GEOCode = row.cityCode;
      bindMappingForm.remoteSystemMappingCode =
        fetchMappingData.data.length > 0
          ? fetchMappingData.data[0].remoteSystemLocationCode
          : "";
      this.bindMappingForm = {
        ...bindMappingForm,
        ...fetchMappingData,
        ...row,
      };
    },
    // 删除映射
    async deleteMapping(row) {
      const that = this;
      const fetchMappingRequests = {
        type: "locationmapping",
        paramsObj: {
          params: {
            locationCode: row.locationCode,
            remoteSystemCode: "FX",
          },
        },
      };
      let confirmMsg = "";
      await fetchMapping(fetchMappingRequests)
        .then(async (res) => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              that.deletedialogVisible = true;
              that.delMappingMsg = "您将删除当前区域位置的关联映射，是否继续？";
              let resData = { ...res.data[0], ...row };
              that.clickRow = resData;
            } else {
              confirmMsg = "暂未查询到该国家的映射数据";
            }
          } else {
            confirmMsg = "查询映射失败，请重新操作";
          }
        });
      if (confirmMsg !== "") {
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    async confirmDelMapping() {
      let confirmMsg = "";
      const deleteMappingRequests = {
        type: "locationmapping",
        paramsObj: {
          params: {
            locationCode: this.clickRow.locationCode,
            userName: this.$objBaseInfo.loginID,
            remoteSystemCountryCode: this.clickRow.remoteSystemCountryCode,
            remoteSystemCode: this.clickRow.remoteSystemCode,
          },
        },
      };
      await deleteMapping(deleteMappingRequests)
        .then((res) => {
          if (res.code === 200) {
            if (!res.status) {
              confirmMsg = "删除映射失败";
            } else {
              confirmMsg = "映射已删除";
            }
          } else {
            confirmMsg = "删除映射失败";
          }
        })
        .catch(function () {
          this.delMappingMsg = "";
        });
      if (confirmMsg !== "") {
        this.delMappingMsg = "";
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    //取消button
    cancelAdd() {
      this.dialogFormVisible = false;
      this.clickRow.locationCode = "";
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          locationCode: row.locationCode,
        },
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      if (this.delMappingMsg !== "") {
        this.confirmDelMapping();
        return false;
      }
      deletelocationList(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.customSearch();
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        });
    },
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    typechange(vId) {
      let obj = {};
      obj = this.locationtypeoption.find((item) => {
        return item.id === vId; //筛选出匹配数据
      });
      this.form.locationtype = obj.type;
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    closeaddDialog(formRule) {
      this.$refs[formRule].resetFields();
    },
    cancel() {
      this.$refs.bindMappingInput.clearValidate();
      this.bindMappingFlag = false;
      this.delMappingMsg = "";
      this.bindMappingForm.remoteSystemMappingCode = "";
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    selectClient(item) {
      this.searchForm.client = item.customerName;
      this.form.name = item.customerName;
      this.locationCode = item.customerCode;
    },
  }
};
</script>
<style scoped>
.pos_container_panel {
  padding-bottom: 4rem;
  padding-left: 2rem;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
.demo-form-inline{
  margin-left: 6rem;
  padding-top: 2rem;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  display: flex;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
</style>
